import { useSelector } from 'react-redux'
import styled from 'styled-components'
import PageTopTitle from '../../components/shared/PageTopTitle'
import darkLogo from "../../images/svg/colors/dark/kamyoon-dark.svg"
import lightLogo from "../../images/svg/colors/light/kamyoon-light.svg"
const Container = styled.div`
  width: 100%;
  height: 100%;
    .wrapper{
      width: 100%;
      padding: 30px;
      .content{
        /* display: flex;
        flex-direction: column;
        align-items: center; */
        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: center;
        height: 40vh;
        gap: 20px;
        img{
          width: 200px;
        }
        p{
          font-size: var(--font-size-lg);
          font-weight: var(--font-weight-lg);
        }
        .titles {
          width: 100%;
          gap: 10px;
          padding-inline: 10px;
          font-size: var(--font-size-sm);
          font-weight: var(--font-weight-lg);
          text-align: center;
          color: ${({ theme }) => theme.mainTextColor};
          display: flex;
          align-items: center;
          justify-content: space-between;
        }
      }
    }

`
const BanaKesilenEArsivFaturalar = () => {
  const {theme} = useSelector((state) => state.layout)

  const titles = ["Tarihi", "Mal / Hizmet", "Miktarı", "Birim Fiyatı (KDV Hariç)", "KDV Oranı (%)", "KDV Tutarı", "KDV Dahil Tutar"]

  return (
    <Container>
        <PageTopTitle title={"Bana Kesilen e-Arşiv Faturalar"} position='sticky' top='210px'/>

        <div className="wrapper">
          <div className="content">
            {/* <div className="titles">
              {titles.map((item) => (
                <div className='title'>{item}</div>
              ))}
            </div> */}
            <img src={theme === "light" ? lightLogo : darkLogo} alt="" />
            <p>Bana Kesilen e-Arşiv Faturalar sayfamız yakında hizmetinize sunulacaktır.</p>
          </div>
          
        </div>
    </Container>
  )
}

export default BanaKesilenEArsivFaturalar